
<div class="loader-overlay" *ngIf="IsLoadingData">
    <div class="loader-overlay-box">
      <span class="fa fa-spinner fa-spin"></span>
    </div>
</div>

<div class="row">
    <div class="col-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons
        [ContextMenuItems]="modelData.MainList.TableContextMenuItems"
        [actionService]="actionService"
        [ContextMenuIndicator]="'racun'"
      >
           <!-- Otpremnica -->
            <!-- <div class="btn-group mr-2">
                <button
                    [disabled]="baseUpdate.Item.ID==-1 || !hasUserRightsPrintDispatch"
                    class="btn btn-outline-primary"
                    type="button"
                    id="btnPrintDispatch"
                    container="body"
                    (click)="PrintDispatch(baseUpdate.Item.ID)"
                    *ngIf="baseUpdate.fcd && baseUpdate.fcd['PrintDispatch'] && baseUpdate.fcd['PrintDispatch'].IsVisible"
                    ngbTooltip="{{'FAKDOKUMENT.PRINTDISPATCH.TOOLTIP' | translate }}"
                    placement="bottom"
                >
                <i class="fa fa-fw fa-print"></i>
                <span style="padding-left: 5px;" translate="FAKDISPATCH.SINGULAR"></span>
            </button>                
            </div> -->

            <!-- Ponude/predracuni -->
            <!-- <div class="btn-group mr-2">
                <button [disabled]="baseUpdate.Item.ID==-1 || !hasUserRightsOdabirDokumenta || !baseUpdate.Item.Editable" class="btn btn-outline-primary" type="button" id="btnOdaberi" container="body"
                    (click)="OdaberiDokumenta()" *ngIf="baseUpdate.fcd && baseUpdate.fcd['OdabirDokumenta'] && baseUpdate.fcd['OdabirDokumenta'].IsVisible" 
                    ngbTooltip="{{'FAKDOKUMENT.ODABIRDOKUMENATA.TOOLTIP' | translate }}" placement="bottom">
                    <i class="fas fa-file-import control-label"></i>
                    <span style="padding-left: 5px;" translate="FAKDOKUMENT.ODABIRDOKUMENATA.SINGULAR"></span> -->
                    <!-- Odabir dokumenata -->
                <!-- </button>
            </div> -->

            <div class="btn-group mr-2">
                <button [disabled]="baseUpdate.Item.ID==-1 || !hasUserRightsOdabirRacuna || !baseUpdate.Item.Editable" class="btn btn-outline-primary" type="button" id="btnOdaberi" container="body"
                    (click)="OdaberiDokumenta()" *ngIf="baseUpdate.fcd && baseUpdate.fcd['OdabirRacuna'] && baseUpdate.fcd['OdabirRacuna'].IsVisible"
                    ngbTooltip="{{'FAKDOKUMENT.ODABIRRACUNA.TOOLTIP' | translate }}">
                    <i class="fas fa-file-import control-label"></i>
                    <span style="padding-left: 5px;" translate="FAKDOKUMENT.ODABIRRACUNA.SINGULAR"></span>
                </button>
            </div>
            
      
            
            <!-- <div style="width: 42%; text-align: right; margin-right: 2%;"> -->
            <div style="width: 42%; text-align: left; margin-left: 2%;">
                <h2 style="display: inline-block; color: #71b1d1;">
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'fak/racun'"><span translate="FAKDOKUMENT.NEW.RACUN"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'fak/ponuda'"><span translate="FAKDOKUMENT.NEW.PONUDA"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'fak/predracun'"><span translate="FAKDOKUMENT.NEW.PREDRACUN"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'fak/avansni'"><span translate="FAKDOKUMENT.NEW.AVANSNIRACUN"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'fak/KnjiznaOdobrenja'"><span translate="FAKDOKUMENT.NEW.KNJIZNOODOBRENJE"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'fak/KnjiznaZaduzenja'"><span translate="FAKDOKUMENT.NEW.KNJIZNOZADUZENJE"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'fak/izvozniracuni'"><span translate="FAKDOKUMENT.NEW.IZVOZNIRACUN"></span></span>

                    <span *ngIf="baseUpdate.Item.ID > 0">
                        <!-- <span translate="FAKDOKUMENT.BRDOK.SINGULAR"></span> -->
                        <span *ngIf="formControlDataName == 'fak/racun'"><span translate="FAKDOKUMENT.EDIT.RACUN"></span></span>
                        <span *ngIf="formControlDataName == 'fak/ponuda'"><span translate="FAKDOKUMENT.EDIT.PONUDA"></span></span>
                        <span *ngIf="formControlDataName == 'fak/predracun'"><span translate="FAKDOKUMENT.EDIT.PREDRACUN"></span></span>
                        <span *ngIf="formControlDataName == 'fak/avansni'"><span translate="FAKDOKUMENT.EDIT.AVANSNIRACUN"></span></span>
                        <span *ngIf="formControlDataName == 'fak/KnjiznaOdobrenja'"><span translate="FAKDOKUMENT.EDIT.KNJIZNOODOBRENJE"></span></span>
                        <span *ngIf="formControlDataName == 'fak/KnjiznaZaduzenja'"><span translate="FAKDOKUMENT.EDIT.KNJIZNOZADUZENJE"></span></span>
                        <span *ngIf="formControlDataName == 'fak/izvozniracuni'"><span translate="FAKDOKUMENT.EDIT.IZVOZNIRACUN"></span></span>
    
                        <span style="padding-left: 5px">{{baseUpdate.Item.BrojDokumenta}}</span>

                      
                    </span>
                </h2>                 
            </div>
            <!-- [NgStyle]="{'color':baseUpdate.Item.StatusColor}" -->
            <div style="padding-left: 5px; margin-right: 25px; margin-top: 10px;color: #71b1d1;">
                <span *ngIf="baseUpdate.Item.StatusTooltip"
                        text-align="center"                         
                        [translate]="baseUpdate.Item.StatusTooltip">
                </span>
            </div>
            <!-- <div class="btn-group mr-2"> -->
                <!-- <button
                 [disabled]="baseUpdate.Item.ID==-1"
                 [hidden] = "
                  !ShowEUInvoice || (
                    baseUpdate.Item.GenericName != 'iz_fakt'
                    && baseUpdate.Item.GenericName != 'ko'
                    && baseUpdate.Item.GenericName != 'kz'
                    && baseUpdate.Item.GenericName != 'iz_avans'
                  )
                 "
                 class="btn btn-outline-primary"
                 type="button"
                 (click)="EUInvoice(baseUpdate.Item.ID, baseUpdate.Item.BrojDokumenta)"
                 ngbTooltip="{{'FAKDOKUMENT.EUINVOICE.ACTION' | translate }}"
                 container="body"
                >                
                    <i class="fas fa-file-download"></i>
                    <span *ngIf="loadingEUInvoiceInXml" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                </button> -->
                <!-- <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'FAKDOKUMENT.EUINVOICE.ACTION'" [Container]="'body'" 
                    (clicked)="EUInvoice(baseUpdate.Item)" 
                    [IsDisabled]="baseUpdate.Item.ID==-1"
                    [IsHidden]="
                        baseUpdate.Item.GenericName != 'iz_fakt'
                        && baseUpdate.Item.GenericName != 'ko'
                        && baseUpdate.Item.GenericName != 'kz'
                        && baseUpdate.Item.GenericName != 'iz_avans'
                        && baseUpdate.Item.GenericName != 'iz_fakt_iz'"
                    [Model]="'faktura'" [Action]="'Download_XML_racuna'">
                    <i class="fas fa-file-download"></i>
                    <span *ngIf="loadingEUInvoiceInXml" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
 
                </yt-button> 

            </div> -->
            <div class="btn-group mr-2">
                    <!-- <span *ngIf="baseUpdate.Item.StatusTooltip"
                        style="padding-left: 5px"
                        [translate]="baseUpdate.Item.StatusTooltip">
                    </span> -->
                 
                <!-- <button
                 [disabled]="baseUpdate.Item.ID==-1 || loadingSendEUInvoice"
                 [hidden] = "
                  !ShowSendEUInvoice || (                 
                    baseUpdate.Item.GenericName != 'iz_fakt'
                    && baseUpdate.Item.GenericName != 'ko'
                    && baseUpdate.Item.GenericName != 'kz'
                    && baseUpdate.Item.GenericName != 'iz_avans'
                  )
                 "
                 class="btn btn-outline-primary"
                 type="button"
                 (click)="SendEUInvoice(baseUpdate.Item)"
                 ngbTooltip="{{'FAKDOKUMENT.SENDEUINVOICE.ACTION' | translate }}" container="body"
                >
                    <i class="fas fa-file-export"></i>
                    <span *ngIf="loadingSendEUInvoice" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                </button> -->

                <!-- Slanje fakture na sef -->
              <yt-button 
                    [Class]="'btn btn-outline-primary'"
                    [NgbTooltip]="'FAKDOKUMENT.SENDEUINVOICE.ACTION'" 
                    [Container]="'body'" 
                    (clicked)="SendEUInvoice(baseUpdate.Item)" 
                    [IsDisabled]="baseUpdate.Item.ID==-1 || loadingSendEUInvoice || !baseUpdate.Item.Editable || VezanZaPpp"
                    [IsHidden]="                 
                        baseUpdate.Item.GenericName != 'iz_fakt'
                        && baseUpdate.Item.GenericName != 'ko'
                        && baseUpdate.Item.GenericName != 'kz'
                        && baseUpdate.Item.GenericName != 'iz_avans'"
                    [Model]="'faktura'" 
                    [Action]="'Upload_XML_Sef_ERacun'">
                    <i class="fas fa-file-export"></i>
                    <span *ngIf="loadingSendEUInvoice" class="loader"><span class="fa fa-spinner fa-spin"></span></span> 
                </yt-button> 
            </div>
            <div class="btn-group mr-2">
                <!-- <button
                    [ngStyle]="{'background-color':bojaStatusa}"
                    [disabled]="baseUpdate.Item.ID==-1"
                    [hidden] = "
                    !ShowSendEUInvoice || (                 
                        baseUpdate.Item.GenericName != 'iz_fakt'
                        && baseUpdate.Item.GenericName != 'ko'
                        && baseUpdate.Item.GenericName != 'kz'
                        && baseUpdate.Item.GenericName != 'iz_avans'
                    )
                    "
                    class="btn btn-outline-primary"
                    type="button"
                    (click)="RefreshStatusClick()"
                    ngbTooltip="{{'FAKDOKUMENT.OSVEZISTATUS.ACTION' | translate }}" container="body"
                >
                    <i class="fas fa-sync-alt"></i>
                    <span *ngIf="loadingEUInvoiceStatus" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                </button> -->
                <!-- [NgbTooltip]="'FAKDOKUMENT.OSVEZISTATUS.ACTION'" -->

                <!-- Osvezi status -->   
                     <!-- [NgbTooltip]="baseUpdate.Item.StatusTooltip"  
                      [NgbTooltip]="'FAKDOKUMENT.OSVEZISTATUS.ACTION' "-->
                <yt-button                    
                    [Class]="'btn btn-outline-primary'" 
                    [NgbTooltip]="'FAKDOKUMENT.OSVEZISTATUS.ACTION'"
                    [Container]="'body'"
                    [NgStyle]="{'background-color':bojaStatusa}"
                    [IsDisabled]="baseUpdate.Item.ID==-1"
                    [IsHidden] = "                                     
                        baseUpdate.Item.GenericName != 'iz_fakt'
                        && baseUpdate.Item.GenericName != 'ko'
                        && baseUpdate.Item.GenericName != 'kz'
                        && baseUpdate.Item.GenericName != 'iz_avans'"                  
                    (clicked)="RefreshStatusClick()"                     
                    [Model]="'faktura'" [Action]="'Upload_XML_Sef_ERacun'">
                    <i class="fas fa-sync-alt"></i>                    
                    <span *ngIf="loadingEUInvoiceStatus" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                </yt-button>
            </div>

            <!-- Dodatna polja -->
            <!-- <div class="btn-group mr-2" >
                <button [disabled]="!hasUserRightsDodatnaPolja" class="btn btn-outline-primary" type="button" (click)="UcitajDodatnaPolja()" container="body"
                    ngbTooltip="{{'FAKDOKUMENT.POLJAZAVELIKELANCE.TOOLTIP' | translate }}" placement="bottom"
                    *ngIf="baseUpdate.fcd && baseUpdate.fcd['PoljaZaVelikeLance'] && baseUpdate.fcd['PoljaZaVelikeLance'].IsVisible">
                    <i class="fas fa-file-alt"></i>
                    <span style="padding-left: 5px;" translate="FAKDOKUMENT.POLJAZAVELIKELANCE.SINGULAR"></span>
                </button>
            </div>
             -->
            <!-- Transport -->
            <div class="btn-group mr-2" >
                <button class="btn btn-outline-primary" 
                        type="button" 
                        (click)="UcitajGabariteRobe()" 
                        container="body"
                        ngbTooltip="{{'FAKDOKUMENTIZVOZ.GABARITIROBE.TOOLTIP' | translate }}" placement="bottom"
                        *ngIf="baseUpdate.fcd && baseUpdate.fcd['GabaritiRobe'] && baseUpdate.fcd['GabaritiRobe'].IsVisible"
                        [disabled]="baseUpdate.Item.ID==-1 || !hasUserRightsTransporteri">
                    <i class="fas fa-weight-hanging"></i>
                    <span style="padding-left: 5px;" translate="FAKDOKUMENTIZVOZ.GABARITIROBE.PLURAL"></span>
                </button>
            </div>

            
                  <!-- Avansi -->
                  <div class="btn-group mr-2">
                    <button [disabled]="baseUpdate.Item.ID==-1 || !hasUserRightsOdabirAvansa || !baseUpdate.Item.Editable" class="btn btn-outline-primary" type="button" (click)="UcitajAvanse()" container="body"
                        *ngIf="baseUpdate.fcd && baseUpdate.fcd['OdabirAvansa'] && baseUpdate.fcd['OdabirAvansa'].IsVisible"
                        ngbTooltip="{{'FAKDOKUMENT.ODABIRAVANSA.TOOLTIP' | translate }}">
                        <i class="fas fa-file-alt"></i>
                        <span style="padding-left: 5px;" translate="FAKDOKUMENT.ODABIRAVANSA.SINGULAR"></span>
    
                        <!-- Odabir avansa -->
                    </button>
                </div>
            <!-- <div class="btn-group mr-2" >
                <button [disabled]="!hasUserRightsDodatnaPolja" class="btn btn-outline-primary" type="button" (click)="UcitajTransportere()" container="body"
                    ngbTooltip="{{'FAKDOKUMENT.POLJAZATRANSPORTERE.TOOLTIP' | translate }}" placement="bottom"
                    *ngIf="baseUpdate.fcd && baseUpdate.fcd['PoljaZaTransportere'] && baseUpdate.fcd['PoljaZaTransportere'].IsVisible">
                    <i class="fas fa-file-alt"></i>
                    <span style="padding-left: 5px;" translate="FAKDOKUMENT.POLJAZATRANSPORTERE.SINGULAR"></span>
                </button>
            </div> -->


            <div class="btn-group mr-2">
                    <!-- [hidden] = "!ShowSendEUInvoice || baseUpdate.Item.MasterDokumID == 0"     -->
                <button
                 [disabled]="baseUpdate.Item.ID==-1"
                 [hidden] = "true"
                 class="btn btn-outline-primary"
                 type="button"
                 (click)="ReciveEUInvoice(baseUpdate.Item)"
                 ngbTooltip="{{'FAKDOKUMENT.RECIVEEUINVOICE.ACTION' | translate }}" container="body"
                >
                    <i class="fas fa-file-download"></i>
                    <span *ngIf="loadingReciveEUInvoice" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                </button>
            </div>

            <!-- Povezano s dokumentima -->
            <!-- <div class="btn-group ml-auto mr-2">
                <button [disabled]="baseUpdate.Item.ID==-1 || !hasUserRightsVezaSaDodatnimDokumentima" [hidden] = "baseUpdate.Item.ID == -1 || baseUpdate.Item.GenericName == 'ko' || baseUpdate.Item.GenericName == 'kz'" class="btn btn-outline-primary" type="button" (click)="Iskoriscen()"
                    ngbTooltip="{{'FAKDOKUMENT.ISKORISCEN.ACTION' | translate }}" container="body">
                    <i class="fas fa-file-alt"></i>
                    <span style="padding-left: 5px;" translate="FAKDOKUMENT.ISKORISCEN.SINGULAR"></span>
                </button>
            </div> -->
        </yt-fw-default-update-buttons>


    </div>

</div>
<yt-fak-dokument-update #baseUpdate></yt-fak-dokument-update>
